import styled from 'styled-components';
import Colors from 'utils/Colors';

export default styled.div`
  background-color: ${Colors.red};
  width: 40px;
  height: 40px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
